import { Button } from '@radix-ui/themes';
import { CommonDialog } from 'components/common/dialog';
import { EB } from 'components/layout/error-boundary';
import { FormContext, FormProvider } from 'contexts/form';
import { FormDialogDef } from 'interfaces/dialog';
import { useContext, useMemo } from 'react';

const Content = (props: FormDialogDef) => {
  const { data, errors, onSubmit } = useContext(FormContext);

  const submitButton = useMemo(() => {
    if (!props.submitAction) {
      return;
    }

    return (
      <Button
        variant="soft"
        disabled={errors.length > 0}
        onClick={async () => {
          if (!props.submitAction) {
            console.error('No form action provided');
            return;
          }

          // sets a lastSubmitted value => untouched inputs that are in error will show their hints
          onSubmit();

          if (errors.length > 0) {
            console.error(
              `Form blocked by ${
                errors.length
              } error(s) for the following field(s):\n${errors.join('\n')}`
            );
            return;
          }

          const success = await props.submitAction.onClick(data);

          if (!success) {
            console.error('Form action was not successful', data);
            return;
          }

          // close after successful action (e.g. data was saved)
          props.onClose();
        }}
      >
        {props.submitAction.label}
      </Button>
    );
  }, [props.submitAction, errors, data]);

  return <CommonDialog {...props} extraActions={submitButton} />;
};

export const CommonFormDialog = (props: FormDialogDef) => {
  return (
    <EB>
      <FormProvider defaultData={props.formData}>
        <Content {...props} />
      </FormProvider>
    </EB>
  );
};
